import React from 'react';

export const Flag = (props) => (
    <svg viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3.2 1C3.2 0.447 2.753 0 2.2 0S1.2 0.447 1.2 1V2.4 9.6 12.8 19.2c0 0.707 0.573 1.28 1.28 1.28s1.28-0.573 1.28-1.28v-5.12l2.57-0.644c1.644-0.412 3.384-0.22 4.902 0.536 1.768 0.884 3.82 0.992 5.668 0.296l1.388-0.52c0.5-0.188 0.832-0.664 0.832-1.196V4.332c0-0.92-0.968-1.52-1.792-1.108l-0.384 0.192c-1.852 0.928-4.032 0.928-5.884 0-1.404-0.704-3.016-0.88-4.54-0.5L3.2 1.92V1z"/>
    </svg>
)